/*
 * 渠道管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'channel',
  name: 'BusinessChannel',
  component: EmptyRouterAlive,
  meta: {
    title: '渠道管理',
  },
  children: [
    {
      path: 'online',
      name: 'BusinessChannelOnline',
      component: EmptyRouter,
      redirect: 'online/index',
      meta: {
        title: '网店管理',
        isCache: true,
      },
      children: [
        {
          path: 'index',
          name: 'BusinessChannelOnline',
          component: () => import('@/views/center-business/channel/online'),
          meta: {
            title: '网店管理',
            isCache: true,
          },
        },
        /** 分配物流  */
        {
          path: 'distribution',
          name: 'BusinessChannelOnlineFlowDistribution',
          component: () => import('@/views/center-business/channel/online/flowdistribution'),
          meta: { title: '分配物流', isCache: true },
          hidden: true,
        },
        /** 分配物流 end */
        /** 网店价格管理 */
        {
          path: 'price',
          name: 'BusinessChannelOnlinePriceManagement',
          component: () => import('@/views/center-business/channel/online/price-management'),
          meta: { title: '网店商品价格管理' },
          hidden: true
        },
        {
          path: '',
          name: 'BusinessChannelOnlinePriceManagement_Add',
          meta: { title: '新增商品价格' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlinePriceManagement_Edit',
          meta: { title: '编辑商品价格' },
          hidden: true,
        },
        /** 网店价格管理 end*/
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessChannelOnlineList_Add',
          meta: { title: '创建网店', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineList_Edit',
          meta: { title: '编辑网店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineList_Delete',
          meta: { title: '删除网店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineList_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineList_Auth',
          meta: { title: '授权' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineList_Log',
          meta: { title: '日志' },
          hidden: true,
        },
      ],
    },
    {
      path: 'physical',
      name: 'BusinessChannelPhysical',
      component: EmptyRouter,
      redirect: 'physical/index',
      meta: {
        title: '门店管理',
        isCache: true,
      },
      children: [
        {
          path: 'index',
          name: 'BusinessChannelPhysical',
          component: () => import('@/views/center-business/channel/physical'),
          meta: {
            title: '门店管理',
            isCache: true,
          },
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessChannelPhysicalList_Add',
          meta: { title: '创建门店', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelPhysicalList_Edit',
          meta: { title: '编辑门店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelPhysicalList_Delete',
          meta: { title: '删除门店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelPhysicalList_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelPhysicalList_Log',
          meta: { title: '日志' },
          hidden: true,
        },
        /** 按钮权限end */
      ],
    },
    {
      path: 'storage',
      name: 'BusinessChannelStorage',
      component: EmptyRouter,
      redirect: 'storage/index',
      meta: {
        title: '仓储管理',
        isCache: true,
      },
      children: [
        {
          path: 'index',
          name: 'BusinessChannelStorage',
          component: () => import('@/views/center-business/channel/storage'),
          meta: {
            title: '仓储管理',
            isCache: true,
          },
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessChannelStorageIndex_Add',
          meta: { title: '创建仓储', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelStorageIndex_Edit',
          meta: { title: '编辑仓储' },
          hidden: true,
        },
        // {
        //   path: '',
        //   name: 'BusinessChannelStorageIndex_Delete',
        //   meta: { title: '删除仓储' },
        //   hidden: true,
        // },
        {
          path: '',
          name: 'BusinessChannelStorageIndex_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelStorageIndex_Log',
          meta: { title: '日志' },
          hidden: true,
        },
        /** 按钮权限end */
      ],
    },
    {
      path: 'warehouse',
      name: 'BusinessChannelWarehouse',
      component: EmptyRouter,
      redirect: 'warehouse/index',
      meta: {
        title: '渠道仓管理',
        isCache: true,
      },
      children: [
        {
          path: 'index',
          name: 'BusinessChannelWarehouse',
          component: () => import('@/views/center-business/channel/warehouse'),
          meta: {
            title: '渠道仓管理',
            isCache: true,
          },
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessChannelWarehouseIndex_Add',
          meta: { title: '创建渠道仓', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelWarehouseIndex_Edit',
          meta: { title: '编辑渠道仓' },
          hidden: true,
        },
        // {
        //   path: '',
        //   name: 'BusinessChannelWarehouseIndex_Delete',
        //   meta: { title: '删除渠道仓' },
        //   hidden: true,
        // },
        {
          path: '',
          name: 'BusinessChannelWarehouseIndex_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        // {
        //   path: '',
        //   name: 'BusinessChannelWarehouseIndex_Log',
        //   meta: { title: '日志' },
        //   hidden: true,
        // },
        /** 按钮权限end */
      ],
    },
    {
      path: 'Tripartite',
      name: 'BusinessChannelOnlineTripartite',
      component: EmptyRouter,
      redirect: 'Tripartite/index',
      meta: {
        title: '三方平台管理',
        isCache: true,
      },
      children: [
        // 三方平台管理
        {
          path: 'index',
          name: 'BusinessChannelOnlineTripartite',
          component: () => import('@/views/center-business/channel/online/Tripartite'),
          meta: {
            title: '三方平台管理',
            isCache: true,
          },
        },
      ],
    },
  ],
};
